import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LOADING_BAR_CONFIG, LoadingBarConfig, LoadingBarModule, LoadingBarService } from '@ngx-loading-bar/core';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { delayWhen, interval, Observable, of } from 'rxjs';

@Component({
  selector: 'rms-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressBarModule, LoadingBarModule, LoadingBarRouterModule, AsyncPipe],
  providers: [
    {
      provide: LOADING_BAR_CONFIG,
      useValue: {
        latencyThreshold: 80,
      } as LoadingBarConfig,
    },
  ],
})
export class ProgressBarComponent {
  /** LoadingBarRouterModule feeds router navigations into the 'router' ref. */
  public readonly value$: Observable<number>;

  private readonly loader = inject(LoadingBarService);

  constructor() {
    this.value$ = this.loader
      .useRef('router')
      .value$.pipe(delayWhen((value) => (value === 0 ? interval(200) : of(undefined))));
  }
}
